
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// @services
import couriersAPI from '@/new-services/couriers.service'

// @types
import { CourierSchedule, GetCourierScheduleResponse } from '@/new-services/types/couriers'

// @composable
import useNotifications from '@/common/composable/useNotifications'

// @constants
import { WORK_WEEK_DAYS } from '@/core/constants/companies.constants'

// UI
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    name: 'courier-schedule',
    components: {
        TheButton,
        Loader,
    },
    props: {
        courierId: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            schedule: [] as CourierSchedule[],
        })

        const loadCourierSchedule = async () => {
            try {
                state.is_loading = true

                const response = await couriersAPI.getCourierSchedule(props.courierId)
                state.schedule = response.data.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении графика работы курьера произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(() => {
            loadCourierSchedule()
        })

        const isProcessing = computed(() => {
            return state.is_loading || state.is_failed || !state.schedule.length
        })

        return {
            state,
            //
            loadCourierSchedule,
            //
            isProcessing,
            //
            WORK_WEEK_DAYS,
        }
    },
})
